import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore, useAppStoreState } from "store/AppStore";
import { useTheme } from "@fluentui/react";
import { toInteger } from "lodash";
import {
  useClGrecoCompanyNumbers,
  useInsurersCountryCode,
  useRemindersCreateDialogStoreActions,
} from "store/RemindersCreateDialogStore";
import Select from "react-select";

export const SearchInsurerCountry = () => {
  const { t } = useTranslation();
  const { taxonomy } = useAppStoreState();
  const taxonomyKey = "Country";
  const { setRemindersCreateDialogStoreValue } =
    useRemindersCreateDialogStoreActions();
  const [{ insurersCountryCode }] = useInsurersCountryCode();
  const [{ clGrecoCompanyNumbers }] = useClGrecoCompanyNumbers();
  const options = useMemo(() => {
    if (!taxonomy || !taxonomy[taxonomyKey]) return [];
    const options = taxonomy[taxonomyKey]?.items
      .map((tax) => {
        return {
          value: tax.id,
          label: t(tax.code),
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    return options;
  }, [t, taxonomy, taxonomyKey]);

  const { appState, grecoCompanies } = useAppStoreState();

  const customStyles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "#222222", // Or any desired color
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      // minHeight: "30px", // reduce the height
      // height: "30px",
      // padding: "0 6px",

      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "white", // Or any desired color
    }),
    valueContainer: (provided) => ({
      ...provided,
      // height: "30px",
      // padding: "0 6px",
      // alignItems: "center", // vertically center the text
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      color: appState.darkMode ? "white" : "#222222",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: appState.darkMode ? "white" : "#222222",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? appState.darkMode
            ? "#000000"
            : "#eeeeee"
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? appState.darkMode
            ? "white"
            : "#222222"
          : appState.darkMode
          ? "white"
          : "#222222",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "yellow"
              : appState.darkMode
              ? "white"
              : "white"
            : undefined,
        },
      };
    },
  };

  useEffect(() => {
    const companyCountryCodeId = grecoCompanies?.find(
      (el) => el.companyNumber === clGrecoCompanyNumbers[0]
    ).companyCountryCodeId;
    setRemindersCreateDialogStoreValue(
      "clInsurersCountryCode",
      options.find((option) => option.value === companyCountryCodeId)
    );
  }, [grecoCompanies, clGrecoCompanyNumbers, options]);

  return (
    <>
      <Select
        required={true}
        onChange={(data) => {
          setRemindersCreateDialogStoreValue("clInsurersCountryCode", data);
        }}
        value={insurersCountryCode || ""}
        styles={customStyles}
        placeholder={t("pct.taxonomy.selectTitle.label")}
        options={options}
      />
    </>
  );
};

export default SearchInsurerCountry;
